export class BatchLogsSearch {
  constructor (batchLogsSearch) {
    this.dateDebut = batchLogsSearch ? batchLogsSearch.dateDebut : null
    this.dateFin = batchLogsSearch ? batchLogsSearch.dateFin : null
    this.nomBatch = batchLogsSearch ? batchLogsSearch.nomBatch : null
    this.batchStatusKO = batchLogsSearch ? batchLogsSearch.batchStatusKO : null
    this.hasRejects = batchLogsSearch ? batchLogsSearch.hasRejects : null
    this.parameters = batchLogsSearch ? batchLogsSearch.parameters : null
    this.execDateOrder = batchLogsSearch ? batchLogsSearch.execDateOrder : null
    this.beginIndex = batchLogsSearch ? batchLogsSearch.beginIndex : null
    this.endIndex = batchLogsSearch ? batchLogsSearch.endIndex : null
  }
}
